import { cn, InfoIcon } from "@au-schein-de/au-ui-library";
import { Trans, useTranslation } from "react-i18next";
import { nonTopPharmacyToggleButtonClassName } from "~/features/products/pharmacy-picker/pharmacy-picker.utils";
import { useStuckObserver } from "~/features/products/pharmacy-picker/use-stuck-observer.hook";

type NonTopPharmacyBannerProps = {
	onHide: () => void;
	breakoutClassName?: string;
	showExpertWarning?: boolean;
};

export function NonTopPharmacyBanner({
	onHide,
	breakoutClassName = "-mx-5 px-5 md:-mx-11 md:px-11",
	showExpertWarning = true,
}: NonTopPharmacyBannerProps) {
	const { t } = useTranslation("product");
	const { sentinelRef, isStuck } = useStuckObserver();
	return (
		<div
			className={cn(
				"sticky top-0 z-10 flex flex-col gap-2",
				breakoutClassName,
				isStuck
					? "bg-white pb-2 md:pb-4 shadow-[0_4px_20px_0_rgba(33,42,54,0.1)]"
					: "bg-gray-100",
			)}
			data-testid="non-top-pharmacy-banner"
		>
			<div
				ref={sentinelRef}
				aria-hidden="true"
				className="pointer-events-none absolute inset-x-0 -top-1 h-px"
			/>
			<button
				type="button"
				className={cn(nonTopPharmacyToggleButtonClassName, isStuck && "pt-1")}
				onClick={onHide}
				data-testid="hide-non-top-pharmacies"
			>
				{t("vendor.picker.hideNonTop")}
			</button>
			{showExpertWarning ? (
				<div
					className="flex items-start gap-2 rounded-xl bg-warning-100 px-3 py-2"
					data-testid="pharmacy-picker-expert-warning"
				>
					<span className="shrink-0 mt-0.5">
						<InfoIcon.Filled size={4} colorToken="warning-400" />
					</span>
					<p className="text-body-sm text-gray-700">
						<Trans
							i18nKey="vendor.picker.expertWarning"
							ns="product"
							components={{
								bold: <span className="text-body-sm-emphasis" />,
							}}
						/>
					</p>
				</div>
			) : null}
		</div>
	);
}
